module.exports = __webpack_public_path__ + "img/merchant-active.e2964b73.svg";